module.exports = __webpack_public_path__ + "static/media/doutor.0604b513.svg";